<template>
    <div
        class="flex flex-col-reverse md:flex-row md:divide md:divide-x md:divide-slate-20"
    >
        <div class="flex flex-auto flex-col overflow-auto md:pr-10">
            <div class="flex w-full flex-auto flex-col">
                <EmptyState
                    v-if="dayEvents.length === 0"
                    icon="bed"
                    title="No Award Availability for This Day"
                    description="Try to choose another day or view"
                    :show-animation="false"
                    action-label="View All Availability"
                    @action="gotoAllAvailability()"
                />
                <div>
                    <ul
                        role="list"
                        class="w-full flex flex-col divide-y divide-slate-200"
                    >
                        <ListItem
                            :event="event"
                            v-for="event in dayEvents"
                            :key="event"
                        />
                    </ul>
                </div>
            </div>
        </div>
        <div
            class="w-full md:w-1/2 mx-auto md:mx-0 max-w-sm flex-none mb-10 md:mb-0 md:pl-6"
        >
            <CalendarMonth
                size="mini"
                :show-full-weeks="false"
                :active-past-dates="false"
            />
        </div>
    </div>
</template>
<script>
import { mapState } from 'pinia';
import { useCalendarStore } from '@/store/calendar';

import CalendarMonth from '@/components/calendar/views/month.vue';
import ListItem from '@/components/calendar/partials/list-item.vue';
import EmptyState from '@/components/ui/empty-state/empty-state.vue';

export default {
    name: 'CalendarDay',
    props: {
        size: {
            type: String,
            default: 'full', // full | mini
        },
    },
    components: {
        CalendarMonth,
        ListItem,
        EmptyState,
    },
    computed: {
        ...mapState(useCalendarStore, [
            'activeDate',
            'dayEvents',
            'gotoAllAvailability',
        ]),
    },
};
</script>
